import jwt_decode from "jwt-decode";

import {
  admin_admin,
  admin_bp,
  admin_cse,
  admin_csm,
  provider_pcp,
  user_patient,
} from "@/config/roles";
import type { UUID } from "@/core/types";

type DecodedToken = {
  "cognito:groups": string[];
  "cognito:username": string;
};

const getRoleFromToken = (token: DecodedToken): string => token["cognito:groups"][0];

export const isProvider = (role: string | null | undefined): boolean =>
  Boolean(role && role.startsWith("provider"));

export const getRole = (): string | false => {
  const token = window.localStorage.getItem("token");

  if (!token) return false;

  return getRoleFromToken(jwt_decode(token) as DecodedToken);
};

export const isUserBehavioral = (): boolean => {
  const token = window.localStorage.getItem("token");

  if (!token) return false;

  return getRoleFromToken(jwt_decode(token) as DecodedToken) === "provider:behavioral";
};

export const isUserPrescriber = (): boolean => {
  const token = window.localStorage.getItem("token");

  if (!token) return false;

  return getRoleFromToken(jwt_decode(token) as DecodedToken) === "provider:prescribe";
};

export const isAuthorized = (group: string): boolean => {
  const token = window.localStorage.getItem("token");

  if (!token) return false;

  return getRoleFromToken(jwt_decode(token) as DecodedToken) === group;
};

export const isUserAdmin = (): boolean =>
  isAuthorized(admin_admin) ||
  isAuthorized(admin_csm) ||
  isAuthorized(admin_cse) ||
  isAuthorized(admin_bp);

export const isAdminCSM = (): boolean => isAuthorized(admin_csm);

export const isUserPCP = (): boolean => isAuthorized(provider_pcp);

export const isUserPeerOrCM = (): boolean =>
  isAuthorized("provider:peer") || isAuthorized("provider:case_manager");

export const isUserPatient = (): boolean => isAuthorized(user_patient);

export const getGroupAuthType = (): string => {
  const token = window.localStorage.getItem("token");

  if (!token) return "";

  return getRoleFromToken(jwt_decode(token) as DecodedToken).split(":")[0];
};

export const getUsernameFromToken = (): UUID | undefined => {
  const idToken = window.localStorage.getItem("token");

  if (idToken) {
    return (jwt_decode(idToken) as DecodedToken)["cognito:username"] as UUID;
  }

  return undefined;
};

export const getUserSubType = (
  profile: Record<string, unknown> | null | undefined,
): string | undefined => {
  if (!profile) return undefined;

  const groupAuthType = getGroupAuthType();

  if (!groupAuthType) return undefined;

  switch (groupAuthType) {
    case "admin":
      return profile.user_type as string;

    case "provider":
      return profile.provider_type as string;

    case "user":
      return "PATIENT";

    default:
      return undefined;
  }
};
